import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef  } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { CoreTranslationService } from '@core/services/translation.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from 'app/core/service';

@Component({
  selector: 'horizontal-layout',
  templateUrl: './horizontal-layout.component.html',
  styleUrls: ['./horizontal-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HorizontalLayoutComponent implements OnInit, OnDestroy {
  coreConfig: any;
  userInfo: any;

  // Private
  private _unsubscribeAll: Subject<void>;
  languageReseted: boolean;

  /**
   * Constructor
   *
   * @param _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    public _translateService: TranslateService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
    private _coreTranslationService: CoreTranslationService) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.userInfo = this.authenticationService.currentUserValue;
      this.coreConfig = config;
      this.changeDetectorRef.detectChanges();
    });

  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
